import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { TranslateService } from '@ngx-translate/core';

import { fuseAnimations } from '@fuse/animations';
import { ConversationFlowService } from 'app/main/apps/conversations-flow/providers/conversations-flow.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'beplic-assign-flow-list',
  templateUrl: './assign-flow-list.component.html',
  styleUrls: ['./assign-flow-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class AssignFlowListComponent implements OnInit {
  countAssignedRooms: number = 0;
  flows = [];

  flowSelected: any;

  constructor(
    private translate: TranslateService,
    public matDialogRef: MatDialogRef<AssignFlowListComponent>,
    private conversationsFlowService: ConversationFlowService,
    @Inject(MAT_DIALOG_DATA) private _data: any
  ) {}

  ngOnInit() {
    this.flowSelected = this._data.flow;
    this.filterFreeAndAssignedRooms(this._data.rooms);
  }

  filterFreeAndAssignedRooms(rooms: any[]) {
    // Primero hacemos una copia del array original para no modificarlo
    this.flows = [...rooms];

    // Actualizamos el contador basado en las salas que están asignadas a este flujo
    const assignedRooms = rooms.filter(room => room.flowId === this.flowSelected.id);
    this.updateCountAssignedRooms(assignedRooms);
  }

  selectedItem(room: any) {
    this.validateConversationFlowAssignment(this.flowSelected.id, room);
  }

  submit() {
    const invalidSelection = this.flows.some(flow => flow.validSelection === false);
    if (!invalidSelection) {
      this.matDialogRef.close(['save', this.flows]);
    }
  }

  checkValidFlowSelection() {
    return this.flows.some(flow => flow.validSelection === false);
  }

  updateCountAssignedRooms(customeruserRooms: any[]) {
    const assignedRooms = customeruserRooms.filter(
      customeruserRoom => customeruserRoom.assigned
    );
    // const assignedRoomss = customeruserRooms.filter(customeruserRoom => customeruserRoom.assigned && customeruserRoom.flowId === null);

    this.countAssignedRooms = assignedRooms.length;
  }

  validateConversationFlowAssignment(flowId: number, room: any) {
    const body = {
      assignments: [
        {
          roomId: room.roomId,
          conversationFlowId: flowId,
          selected: room.assigned,
        },
      ],
    };

    this.conversationsFlowService
      .validateConversationFlowAssignment(body)
      .subscribe(resp => {
        const item =
          resp && resp.items && resp.items.length > 0 ? resp.items[0] : null;

        if (item && item.assignable === false && room.assigned === true) {
          room.validSelection = false;
          this.showAssignmentValidationAlert(item.reasons || []);
        } else {
          room.validSelection = true;
        }

        const customerUserRoomToFind = this.flows.find(
          flow => flow.roomId === room.roomId
        );
        if (customerUserRoomToFind) {
          customerUserRoomToFind.assigned = room.assigned;
          customerUserRoomToFind.validSelection = room.validSelection;
        } else {
          this.flows.push(room);
        }

        this.updateCountAssignedRooms(this.flows);
      });
  }

  showAssignmentValidationAlert(reasons: any[]) {
    if (reasons.some(reason => reason.code === 'ROOM_HAS_ASSIGNED_AGENT')) {
      this.showAlert(
        this.translate.instant(
          'ADMINISTRATION.ROOMS.FLOW.ASSIGNMENT.ERROR.AGENT_ASSIGNED'
        )
      );
      return;
    }

    if (reasons.some(reason => reason.code === 'DUPLICATED_KEYWORDS')) {
      this.showAlert(
        this.translate.instant(
          'ADMINISTRATION.ROOMS.FLOW.ASSIGNMENT.ERROR.DUPLICATED_KEYWORDS'
        )
      );
    }
  }

  showAlert(message: string) {
    Swal.fire({
      title: this.translate.instant('ADMINISTRATION.ROOMS.WARNING'),
      text: message,
      type: 'warning',
      showCancelButton: false,
      confirmButtonColor: '#e2ae2f',
      confirmButtonText: this.translate.instant('ACCEPT'),
      width: '40rem',
    });
  }
}
